module.exports = __webpack_public_path__ + "media/svg/my-05adc6be.svg";